import Input from "../components/common/input";
import React from "react";
import {dateToString, stringToDate} from "./dateTimeFormat";
import SelectByList from "../components/common/selectByList";
import SelectByMap from "../components/common/selectByMap";
import MultiSelectCheckbox from "../components/common/multiSelectCheckbox";
import RadioButton from "../components/common/radioButton";
import DetailTable1 from "../components/common/detailTable1";

export function renderInput(configuration, value, errors, handleChange) {

    const {type, name, label, help, autofocus, disabled, ...rest} = configuration;

    return (
        <Input
            type={type ? type : "text"}
            name={name}
            label={label ? label : ""}
            value={value}
            error={errors[name]}
            onChange={handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? autofocus : null}
            disabled={disabled ? disabled : null}
            {...rest}
        />
    );

}

export function renderDateTimeInput(configuration, value, errors, handleChange) {

    const {type, name, label, help, autofocus, disabled, ...rest} = configuration;
    const dateTimeValue = dateToString(stringToDate(value, "YYYYMMDDHHmm"), "YYYY-MM-DDTHH:mm")

    return (
        <Input
            type={type ? type : "datetime-local"}
            name={name}
            label={label ? label : ""}
            value={dateTimeValue}
            error={errors[name]}
            onChange={handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? autofocus : null}
            disabled={disabled ? disabled : null}
            {...rest}
        />
    );
}

export function renderSelectByList(configuration, value, errors, handleChange) {

    const {name, label, itemList, help, autofocus, ...rest} = configuration;

    return (
        // <SelectByList
        <SelectByList
            name={name}
            label={label ? label : ""}
            value={value}
            itemList={itemList}
            error={errors[name]}
            handleItemSelect={configuration.handleItemSelect ? configuration.handleItemSelect : handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? true : null}
            {...rest}
        />
    );
}

export function renderSelectByMap(configuration, value, errors, handleChange) {

    const {name, label, itemsMap, itemList, help, autofocus, ...rest} = configuration;

    return (
        <SelectByMap
            name={name}
            label={label ? label : ""}
            value={value}
            itemsMap={itemsMap}
            itemList={itemList}
            error={errors[name]}
            handleItemSelect={handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? true : null}
            {...rest}
        />
    );
}

export function renderMultiSelectCheckbox(configuration, value, errors, handleChange) {

    const {name, label, itemsMap, itemList, help, autofocus, ...rest} = configuration;

    return (
        <MultiSelectCheckbox
            name={name}
            label={label ? label : ""}
            value={value}
            itemsMap={itemsMap}
            itemList={itemList}
            error={errors[name]}
            handleItemSelect={handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? true : null}
            {...rest}
        />
    );
}

export function renderRadioButton(configuration, value, errors, handleChange) {

    const {name, label, itemsMap, itemList, help, autofocus, ...rest} = configuration;

    return (
        <RadioButton
            name={name}
            label={label ? label : ""}
            value={value}
            itemsMap={itemsMap}
            itemList={itemList}
            error={errors[name]}
            handleItemSelect={handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? true : null}
            {...rest}
        />
    );
}

export function renderDetailTable1(configuration, baseInformation, value, errors) {

    const {name, label, itemsMap, itemList, help, autofocus, ...rest} = configuration;

    return (
        <DetailTable1
            name={name}
            label={label ? label : ""}
            baseInformation={baseInformation}
            value={value}
            itemsMap={itemsMap}
            itemList={itemList}
            error={errors[name]}
            // handleItemSelect={this.handleChange}
            help={help ? help : null}
            autoFocus={autofocus ? true : null}
            {...rest}
        />
    );
}


